import { type ReactNode, useEffect } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "../components/UI/Toast/toaster";
import {
  queryClient,
  setupPrivateInterceptor,
  performLogout,
} from "@core/libs";
import { SidebarProvider } from "@core/context";

type AppProviderProps = { children: ReactNode };

const AppProvider = ({ children }: AppProviderProps) => {
  useEffect(() => {
    // Setup interceptor once on app startup
    setupPrivateInterceptor(performLogout);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <SidebarProvider>
        {children}
        <Toaster />
      </SidebarProvider>
    </QueryClientProvider>
  );
};

export default AppProvider;
